<script>
  // The card overlays (VISUALS.md "A card looks the same everywhere"): the
  // price pill centred on the card's bottom edge, with the rainbow dot when
  // foil, and an "xN" pill straddling the top edge when there is more than
  // one. The binder (binder/CardSlot.svelte) renders these inside its
  // `.binder-overlays`; the want page's card view inside shared/CardTile.
  // Place inside a `position: relative` box holding the card image.

  /** @type {{ price?: number | null, foil?: boolean, quantity?: number, currencySymbol?: string }} */
  let { price = null, foil = false, quantity = 1, currencySymbol = '$' } = $props();
</script>

{#if price != null && price > 0}
  <div class="card-overlay price-indicator">
    {#if foil}
      <span class="price-foil-indicator"></span>
    {/if}
    <span>{currencySymbol}{price.toFixed(2)}</span>
  </div>
{/if}

{#if quantity > 1}
  <div class="card-overlay quantity-indicator">x{quantity}</div>
{/if}

<style>
  .card-overlay {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 13px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 0.75rem;
    z-index: var(--z-card-overlay, 8);
    pointer-events: none;
    line-height: 1.2;
    font-family: monospace;
  }

  .price-indicator {
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .price-foil-indicator {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--foil-gradient);
    flex-shrink: 0;
    box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);
    margin-left: -2px;
  }

  .quantity-indicator {
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 10px;
    padding: 1px 5px;
    background-color: rgba(75, 85, 99, 0.8);
    border: 1px solid rgba(255, 255, 255, 0.3);
    z-index: var(--z-card-quantity, 9);
  }
</style>
